export default {
  data() {
    return {
      start: {
        projectsMissingPlanning: [],
        departmentsMissingEmployees: [],
      },
    };
  },
  methods: {
    async fetchDepartmentsMissingEmployees() {
      this.$startLoading('departmentsMissingEmployees');
      this.start.departmentsMissingEmployees = await this.$api.departments.missingEmployees();
      this.$stopLoading('departmentsMissingEmployees');
    },
    async fetchProjectsMissingPlanning() {
      this.$startLoading('projectsMissingPlanning');
      this.start.projectsMissingPlanning = await this.$api.projects.missingPlanning();
      this.$stopLoading('projectsMissingPlanning');
    },
  },
};
